module.exports = __webpack_public_path__ + "46f0461b6e19880fe446f094bbe787f4.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-HeavyItalic.woff2
// module id = 997
// module chunks = 0